"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/TabComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TabNavComponent = /** @class */ (function (_super) {
    __extends(TabNavComponent, _super);
    function TabNavComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabNavComponent.prototype.render = function () {
        return (react_1.default.createElement("li", { className: "nav-item" },
            react_1.default.createElement("a", { className: this.props.Index === 0 ? "nav-link active" : "nav-link", id: "TC_" + this.props.UniqueKey + "-tab-md", "data-toggle": "tab", href: "#TC_" + this.props.UniqueKey + "-md", role: "tab", "aria-controls": "TC_" + this.props.UniqueKey + "-md", "aria-selected": this.props.Index === 0 ? "true" : "false" }, this.props.Title)));
    };
    return TabNavComponent;
}(react_1.default.Component));
exports.default = TabNavComponent;
